import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached account data
export function useAccountSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/me"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
